export var TNotificationType;
(function (TNotificationType) {
    TNotificationType["success"] = "success";
    TNotificationType["error"] = "error";
    TNotificationType["warning"] = "warning";
})(TNotificationType || (TNotificationType = {}));
//# sourceMappingURL=NotificationTypes.js.map